(function ($) {

  /* ==== WPCF7 ==== */

  /**
   * Input placeholder
   */
  $('.wpcf7-form-control-wrap input').each(function() {

    var wpcf7_placeholder = $(this).attr('placeholder');
    var wpcf7_placeholder_focus = '<span class="placeholder">' + wpcf7_placeholder + ' :</span>';

    $(this).focus(function() {
      if(wpcf7_placeholder != undefined) {
        $(this).attr('placeholder', '');
        $(this).after(wpcf7_placeholder_focus);
      }
    });

    $(this).focusout(function() {
      if(wpcf7_placeholder != undefined) {
        $(this).attr('placeholder', wpcf7_placeholder);
        $(this).parent().find('span.placeholder').remove();
      }
    });

  });

})(jQuery);
